module.exports = __webpack_public_path__ + "static/brothers-c6f5191788db4ebe9eedd67f4b9930a8.jpg";